<template>
  <div class="exam-details">
    <h1>{{ exam_details.title }}</h1>

    <table class="table table-responsive">
      <tbody>
        <tr>
          <td>Number of questions:</td>
          <td v-text="exam_details.presentative_number_of_questions"></td>
        </tr>
        <tr>
          <td>Duration:</td>
          <td v-text="exam_details.duration + ' minutes'"></td>
        </tr>
        <tr>
          <td>Passing score:</td>
          <td v-text="exam_details.passing_score + '%'"></td>
        </tr>
        <tr v-if="exam_details.show_pool_details">
          <td>Number of questions in the pool:</td>
          <td v-text="'equivalent to ' + exam_details.dashboard_eqn_value"></td>
        </tr>
        <tr v-if="exam_details.show_pool_details">
          <td>Number of variations in the pool:</td>
          <td v-text="exam_details.num_variations"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('exam', ['exam_details']),
  },
}
</script>
